import { render, staticRenderFns } from "./index.vue?vue&type=template&id=71c2bacc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=71c2bacc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c2bacc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c2bacc')) {
      api.createRecord('71c2bacc', component.options)
    } else {
      api.reload('71c2bacc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=71c2bacc&scoped=true", function () {
      api.rerender('71c2bacc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report-download/index.vue"
export default component.exports